import React from 'react'
import { Box, Icon, Modal, Text } from '@maui/elements'
import { CampaignDetails } from '../details/CampaignDetails'
import { PageLoading } from '../common/PageLoading'
import { DetailsSection } from '@/components/details/DetailsSection'
import { useCampaignQuery } from '@nautilusjs/mati-apis'
import { ViewObjectLinks } from './ViewObjectLinks'

function CampaignModal({ ...modalProps }) {
  const {
    id,
    name
  } = modalProps

  const { data: campaignData, isLoading } = useCampaignQuery(id)
  const shortName = campaignData?.short_name

  return (
    <Modal {...modalProps} ariaHideApp={false}>
      <Modal.Header onClose={modalProps.onClose}>
        <Box display="flex" alignItems="center" justifyContent="center">
          {campaignData?.campaign_type === 'Individual' ? <Icon name='bullseye' size='lg' /> : <Icon name='triBullseye' size='lg' /> }
          <Box ml="5px">
            <Modal.Title>{name}</Modal.Title>
            {shortName && <Text color='colorTextDeemphasis' ml="2px" fontWeight='700' width='74px' fontSize='10px'>{shortName}</Text>}
          </Box>
        </Box>
      </Modal.Header>
      <Modal.Body>
        <DetailsSection
          title="Campaign Summary"
          headerSlot={campaignData && <ViewObjectLinks path={`/campaigns/${campaignData.id}`} />}
          p="0"
        >
          {isLoading
            ? <PageLoading/>
            : <Box width='900px'><CampaignDetails id={id} data={campaignData} fromModal/></Box>
          }
        </DetailsSection>
      </Modal.Body>
    </Modal>
  )
}

export default CampaignModal
